/** Double-Base64 master_login.token from query (?token= / ?Token=). */
export function readSsoQueryToken(search) {
  const params = new URLSearchParams(search);
  const value = params.get("Token") || params.get("token");
  const trimmed = value != null ? String(value).trim() : "";
  if (!trimmed || /^(undefined|null)$/i.test(trimmed)) {
    return null;
  }
  return trimmed;
}

export function pathWithoutSsoToken(pathname, search) {
  const params = new URLSearchParams(search);
  params.delete("Token");
  params.delete("token");
  const qs = params.toString();
  return `${pathname}${qs ? `?${qs}` : ""}`;
}

export function isAuthRoutePath(pathname) {
  return /^\/auth\//i.test(String(pathname || ""));
}
